module.exports = __webpack_public_path__ + "static/media/note-text.c55ceeb1.svg";